<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentSymLocationId"
            @click="currentSymLocationId = $event.id"
        />

        <sidebar
            :key="currentSymLocationId"
            :sym-location="currentSymLocation"
            v-if="currentSymLocationId"
            @close="currentSymLocationId = null"
        />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import Sidebar from './components/SymLocationSidebar'

export default {
    components: {FastTable, Page, Sidebar},
    computed: {
        currentSymLocation() {
            return this.symLocations.find(l => l.id == this.currentSymLocationId)
        },
        tableData() {
            const sectionData = this.symLocations.map(l => ({
                id: l.id,
                object: l,
                cells: [
                    l.location_code,
                    l.state_abbreviation || '',
                    l.county_code || '—',
                    l.city_code || '—',
                    l.is_active ? 'Yes' : 'No',
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            symLocations: [],
            dataLoaded: false,
            currentSymLocationId: null,

            headers: [
                {label: 'Location Code', classes: '', isSearchable: true, defaultSort: true},
                {label: 'State', classes: 'cw-5', isSearchable: false, isFilterable: true},
                {label: 'County Code', classes: 'cw-8', isSearchable: true},
                {label: 'City Code', classes: 'cw-8', isSearchable: true},
                {label: 'Active', classes: 'cw-5', isFilterable: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Sym Locations')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/tax-engine/sym-locations').then(resp => {
                this.symLocations = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
